import { createAction } from 'redux-actions';

import { RefundSelectedReasonState } from '../types';

export const SET_SELECTED_REASON = 'REFUND/SET_SELECTED_REASON ';

export const setSelectedReason = createAction<RefundSelectedReasonState>(SET_SELECTED_REASON);

export type SetSelectedReasonAction = ReturnType<typeof setSelectedReason>;

export type ActionSelectedReasonTypes = SetSelectedReasonAction;
